import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient } from '@angular/common/http';
import { Currency, SysLocation } from 'src/app/interfaces/currency';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';

@Injectable()
export class CurrencyService {
  private currencies: BehaviorSubject<Currency[]> = new BehaviorSubject<
    Currency[]
  >([]);
  public currencies$: Observable<Currency[]>;

  private locations: BehaviorSubject<SysLocation[]> = new BehaviorSubject<
    SysLocation[]
  >([]);
  public locations$: Observable<SysLocation[]>;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.currencies$ = this.currencies.asObservable();
    this.locations$ = this.locations.asObservable();
  }

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public getCurrencies(): Observable<Currency[]> {
    return this.http.get<Currency[]>(`${this.url}` + requests.getCurrencies);
  }

  public getLocations(): Observable<SysLocation[]> {
    return this.http.get<SysLocation[]>(`${this.url}` + requests.getLocations);
  }

  getLocation(id: string): SysLocation {
    return this.locations.value.find((item) => item.locationId === id);
  }

  getCurrency(id: number): Currency {
    return this.currencies.value.find((item) => item.currencyId === id);
  }

  public setCurrencies(currencies: Currency[]): void {
    this.currencies.next(currencies);
  }
}
